import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addCompanyData,
  deleteCompanyData,
  fetchCompanyListData,
  updateCompanyData,
} from "../../apis/companyList";

export const fetchCompanyList = createAsyncThunk(
  "companyList/fetchCompanyList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await fetchCompanyListData();
      return res;
    } catch (error: any) {
      console.error(error);
      return rejectWithValue(error.message);
    }
  },
    {
      condition: (_, { getState }) => {
        const state = getState() as any; // Replace 'any' with your RootState type
        return !state.companyList.isDataFetched; // Adjust path based on your state structure
      }
    }
);

export const updateCompany = createAsyncThunk(
  "companyList/updateCompany",
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: {
        [key: string]: any;
        companyId: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateCompanyData(id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteCompany = createAsyncThunk(
  "companyList/deleteCompany",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteCompanyData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

export const addNewCompanyData = createAsyncThunk(
  "companyList/deleteCompanyData",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addCompanyData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
